"use client";

import Script from "next/script";
import { FIREBASE_MEASUREMENT_ID } from "~/src/constant/env";

/**
 * Google Analytics コンポーネント
 * 本番環境/staging環境で動作
 */
export default function GoogleAnalytics() {
  //----------
  // 測定IDが設定されていない場合は何も表示しない
  //----------
  if (!FIREBASE_MEASUREMENT_ID) {
    return null;
  }

  return (
    <>
      <Script
        src={`https://www.googletagmanager.com/gtag/js?id=${FIREBASE_MEASUREMENT_ID}`}
        strategy="afterInteractive"
      />
      <Script
        id="google-analytics"
        strategy="afterInteractive"
      >
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${FIREBASE_MEASUREMENT_ID}');
        `}
      </Script>
    </>
  );
}
